// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Badge__badge___3HdoI{font-size:var(--spectrum-global-dimension-size-130)!important}.Badge__badge___3HdoI{align-items:center;font-weight:700;height:var(--spectrum-global-dimension-size-150);justify-content:center;margin:0 var(--spectrum-global-dimension-size-75);padding:var(--spectrum-global-dimension-size-50) 0;white-space:nowrap}", ""]);
// Exports
exports.locals = {
	"badge": "Badge__badge___3HdoI"
};
module.exports = exports;
